<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Attention!</h1>

  <div class="delete-contact-modal">
    <p class="delete-contact-modal__body">
      You are deleting contact

      <span class="delete-contact-modal__subject">
        {{ contactName }}
      </span>
    </p>

    <p class="delete-contact-modal__question">Are you sure?</p>

    <div class="delete-contact-modal__actions">
      <button class="btn_secondary btn_lg" (click)="onClose()">No</button>
      <button class="btn_primary btn_lg" (click)="onSubmit()">Yes</button>
    </div>
  </div>
</app-base-modal>
